import React, { Component } from "react";
import Navbar from "./components/navbar";

class PlaceHolder extends Component {
  
  render() {
    return (
      <div id="body-wrap">
        <Navbar />
      </div>
    );
  }
}

export default PlaceHolder;
//style={{background:"linear-gradient(to bottom right, blue, green)"}}

//https://mdbootstrap.com/docs/react/extended/gradients/